import {FeatureConfig} from '@/shared/constants/featuresFlag'
import {GrowthBook} from '@growthbook/growthbook-react'

// Create a GrowthBook instance
const gb = new GrowthBook({
  apiHost: import.meta.env[FeatureConfig.growthbookURL],
  clientKey: import.meta.env[FeatureConfig.growthbookSdkKey],
  enableDevMode: import.meta.env.MODE === 'development',
})
gb.init({
  // Optional, enable streaming updates
  streaming: false,
  timeout: 1000,
})

export default gb
